// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1gRzY","text":"SelectPayment_text___XEb0","title":"SelectPayment_title__3-8Z8","btn":"SelectPayment_btn__1pIqE"};